import React from "react";
import { useHistory } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import PropTypes from "prop-types";

const DEFAULT_AUTH0_AUDIENCE = "https://prevent.redvent.net/api";

const Auth0ProviderWithHistory = ({ children }) => {
  const history = useHistory();
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience =
    process.env.REACT_APP_AUTH0_AUDIENCE || DEFAULT_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState) => {
    const returnTo =
      appState && typeof appState.returnTo === "string"
        ? appState.returnTo
        : "/portal/highlights";

    history.replace(returnTo);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;

Auth0ProviderWithHistory.propTypes = {
  children: PropTypes.node.isRequired,
};
